<div class="loginbox">
  <div class="tabs">
    <label class="title">{{"ecwid.auth.FulfillmentBridge" | translate: {companyName: currentCompany.name} }}</label>
    <div class="tab">
      <input name="checkbox-tabs-group" type="radio" id="checkbox2" class="checkboxtab">
      <label>
        <a href="https://fulfillmentbridge.com/" target="_blank" style="color: #fff; text-decoration: none;">           
        {{"ecwid.auth.back" | translate }}</a>
      </label>
    </div>

    <div class="tab">
      <input name="checkbox-tabs-group" type="radio" id="checkbox2" class="checkboxtab">
      <label [routerLink]=" ['/ecwid/register'] " [queryParams]="{code: code}">{{"ecwid.auth.register" | translate }}</label>
    </div>

    <div class="tab">
      <input name="checkbox-tabs-group" type="radio" id="checkbox3" class="checkboxtab">
      <label for="checkbox3">{{"ecwid.auth.login" | translate }}</label>
      <div class="content">
        <div class="row col-md-12 col-xs-12" style="display: inline-block;">
          <div class="col-md-6 col-xs-12" style="float: left;">
            <img class="finger" src="../assets/images/logoApp.png">
          </div>
          <div class="col-md-6 col-xs-12" style="float: left;">
            <h4 class="login-title">{{"ecwid.auth.connectwithfb" | translate }}</h4>
            <div class="ui form langage-login">
              <div class="field">
                <input type="text" [(ngModel)]="alias" name="alias" placeholder="{{'modules.user.placeholder.stralias' | translate }}">
              </div>
              <div *ngIf="load" class="field">
                <button class="ui button primary" type="submit" (click)="createShop()">{{"ecwid.auth.connect" | translate }}</button>
              </div>
            </div>
            <form *ngIf="!load" class="ui form" (ngSubmit)="login()" style="text-align: center; margin-top: 20px;">
              <div class="alert alert-danger alert-sm" *ngIf="error">
                <span class="fw-semi-bold">{{"ecwid.auth.login.error" | translate }}</span>.
              </div>
              <div class="field">
                <input type="text" [(ngModel)]="cred.username" name="username"
                  placeholder="{{'ecwid.auth.username' | translate }}">
              </div>
              <div class="field">
                <input type="password" [(ngModel)]="cred.password" name="password"
                  placeholder="{{'ecwid.auth.password' | translate }}">
              </div>
              <div class="field">
              </div>
              <button class="ui button primary" type="submit">"{{'ecwid.auth.login' | translate }}"</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>